<template>
  <div>
    <button
      hidden
      :id="`${id}_offcanvas_button`"
      type="button"
      data-bs-toggle="offcanvas"
      :data-bs-target="`#${id}`"
      aria-controls="staticBackdrop"
    ></button>
    <div
      class="offcanvas offcanvas-end"
      tabindex="-1"
      :id="id"
      aria-labelledby="staticBackdropLabel"
      data-bs-backdrop="static"
    >
      <div class="offcanvas-header justify-content-center">
        <i
          class="fa-solid fa-chevron-circle-left display-5 text-primary25 cursor-pointer position-absolute"
          style="left: 20px"
          @click="offcanvasClosed"
        />

        <p class="offcanvas-title text-pagesubtitle" id="staticBackdropLabel">
          {{ title }}
        </p>

        <!-- à direita: ação da view (ex.: compartilhar, via Teleport em #<id>_header_action) e o X.
             EXCLUSIVO DO MAIN: no pro este X está comentado; aqui só aparece com `showClose` -->
        <div class="offcanvas-header-action gap-3">
          <div :id="`${id}_header_action`" class="d-flex align-items-center"></div>
          <i
            v-if="showClose"
            class="fa-solid fa-circle-xmark display-5 text-primary25 cursor-pointer"
            id="offcanvas_close"
            @click="offcanvasDismissed"
          />
        </div>
      </div>

      <slot />

      <div class="offcanvas-body" v-if="$slots.body">
        <slot name="body"></slot>
      </div>
      <div class="offcanvas-footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string;
    id?: string;
    showClose?: boolean;
  }>(),
  {
    title: "Title",
    id: "",
    showClose: true,
  },
);

const emit = defineEmits<{
  offcanvasClosed: [];
  offcanvasDismissed: [];
}>();

const offcanvasClosed = () => {
  emit("offcanvasClosed");
};

const offcanvasDismissed = () => {
  emit("offcanvasDismissed");
};
</script>
